import validateNumericInput from '../functions/validateNumericInput';
import isAlphaNumeric from '../functions/isAlphaNumeric';
import isNumericOrNull from '../functions/isNumericOrNull';
import removeStrCommas from '../functions/removeStrCommas'; 

const rebateInputValidationChecks = ( input, companyIdsList, masterSetupIdsList, snackbarAlert ) => {
    console.log(input);
    // validate companyid is in company ids list 
    if (!companyIdsList.includes(input.companyid)){
        // show alert on invalid company id
        snackbarAlert(true, 'Invalid Sub Company ID.', 'error');
        return false;
    }
    
    // validate master setup id is in masterSetupIdsList
    if (input.masterincentivesetupid && !masterSetupIdsList.includes(parseInt(input.masterincentivesetupid))){
        // show alert on invalid masterincentivesetupid
        snackbarAlert(true, 'Invalid Master Setup ID.', 'error'); 
        return false; 
    }

    // // validate setupId is alpha numeric
    // if (!isAlphaNumeric(input.incentivesetupid)){
    //     // show alert on invalid setup id
    //     snackbarAlert(true, 'Invalid Setup ID.', 'error');
    //     return false;
    // }

    // validate numeric inputs 
    if (!validateNumericInput(input.minspend) ) {
        // show alert on invalid numeric input
        snackbarAlert(true, 'Invalid Tier Min Input.', 'error');
        return false; 
    }  
    if (!validateNumericInput(input.maxspend) ){
        // show alert on invalid numeric input
        snackbarAlert(true, 'Invalid Tier Max Input.', 'error');
        return false;
    }
    if (!isNumericOrNull(input.incentiverate)){
        // show alert on invalid numeric input
        snackbarAlert(true, 'Invalid Rebate Rate Input.', 'error');
        return false;
    }
    // validate dropdown selections
    if (input.producttypedescription == '--select--' || input.billingratedescription == '--select--' || input.daystopay == '--select--' || input.feecategorydescription == '--select--'){
        // show alert on invalid selection
        snackbarAlert(true, 'Invalid Dropdown Selection.', 'error');
        return false;
    }
    // validate additional details
    if (input.spendcommitment != null && !isNumericOrNull(removeStrCommas(input.spendcommitment))){
        // show alert on invalid numeric input 
        snackbarAlert(true, 'Invalid Minimum Spend.', 'error'); 
        return false; 
    }
    if (input.bonusamount != null && !isNumericOrNull(removeStrCommas(input.bonusamount))){
        // show alert on invalid numeric input
        snackbarAlert(true, 'Invalid Payback Amount.', 'error'); 
        return false; 
    }
    // if passes all checks return true
    return true; 
}

export default rebateInputValidationChecks;